import jsCookies from "js-cookie";
import { addProp } from "utils/Utils";

/**
 * @param {import('models/shop/cart-model').default} cart
 * @param {import('models/member-model').default} user
 * 
 * @returns {Promise<null, Array>}
*/
export function validateCartWithUser(cart, user)
{
  return new Promise((resolve, reject) =>
  {
    const [promise] = user.FetchJSON(`${process.env.API_URL}/shop/cart/validate`, {
      method: "POST",
      data: cart.getData(),
    });

    promise
    .then(({data}) => {
      resolve(data);
    })
    .catch(e =>
    {
      const errorFields = [];
      e.response.data.errorFields.forEach(field => addProp(errorFields, field.split("."), true));

      reject(errorFields);
    })
  })
}

/**
 * @param {import('models/shop/cart-model').default} cart
 * @param {import('models/member-model').default} user
 * 
 * @returns {Promise<null, Array>}
*/
export function validateDiscountWithUser(cart, user)
{
  return new Promise((resolve, reject) =>
  {
    const [promise] = user.FetchJSON(`${process.env.API_URL}/shop/cart/validateDiscount`, {
      method: "POST",
      data: cart.getData(),
    });

    promise
    .then(({data}) => {
      resolve(data);
    })
    .catch(e =>
    {
      const errorFields = [];
      e.response.data.errorFields.forEach(field => addProp(errorFields, field.split("."), true));

      reject(errorFields);
    })
  })
}

/**
 * @param {import('models/shop/cart-model').default} cart
 * 
 * @returns {[Promise, Function]}
*/
export function saveCartWithUser(cart, user)
{
  return new Promise((resolve, reject) =>
  {
    const [promise, cancel] = user.FetchJSON(`${process.env.API_URL}/shop/cart/${cart.key}`, {
      method: "POST",
      data: cart.getData(),
    });

    promise.then(res =>
    {
      const cartData = res.data;
      if(cartData.key && !user.isLoggedIn && (typeof window !== "undefined"))
        jsCookies.set("shoppingcart", cartData.key, {expires: 365, path: "/", secure: true, sameSite: "Lax"});

      cart.hydrate(cartData);
    }).catch(reject);

    resolve([promise, cancel]);
  })
}